import { useEffect, useMemo, useState } from "react";
import "./PaymentMethod.css"; // Import external CSS
import LawnetLogo from "../../../assets/images/LAWNET LOGO.png";
import api from "../../../services/baseUrl";
import { useLocation, useNavigate } from "react-router-dom";
import Modal from "../../eGazette/search/Modal";
import download from "downloadjs";
const PaymentMethod = () => {
  const [selectedMethod, setSelectedMethod] = useState(""); // Store selected payment category

  const [selectedPaymentId, setSelectedPaymentId] = useState(""); // Store only PaymentId
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const [formData, setFormData] = useState(location.state);
  const wartaEmail =
    JSON.parse(sessionStorage.getItem("wartaUser"))?.email || null;
  const [email, setEmail] = useState(formData.email || wartaEmail); // State for email input

  const [userPackage, setUserPackage] = useState();
  const [errors, setErrors] = useState({
    method: "",
    option: "",
    email: "",
    years: "",
    ids: "",
    targetedStartDate: "",
  });
  const [years, setYears] = useState(1);
  const [ids, setIds] = useState(1);
  const [targetedStartDate, setTargetedStartDate] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const navigate = useNavigate();
  // Payment options with their IDs

  const paymentCategories = useMemo(
    () => [
      { key: "creditCard", label: "Credit Card" },
      { key: "onlineBanking", label: "Online Banking (FPX)" },
      { key: "loPo", label: "LO/PO" },
      { key: "invoice", label: "Invoice" },
    ],
    []
  );

  const [filteredCategories, setFilteredCategories] =
    useState(paymentCategories);

  useEffect(() => {
    if (Array.isArray(formData) || formData?.categoryId === 8) {
      setFilteredCategories(
        paymentCategories.filter(
          (cat) => cat.key === "creditCard" || cat.key === "onlineBanking"
        )
      );
    } else {
      setFilteredCategories(paymentCategories); // Reset to default if condition not met
    }

    const fetchCustomer = async (id) => {
      const response = await api.get("/user/customer", {
        params: { id },
      });
      if (response.status === 200) {
        setFormData((prev) => ({
          ...prev,
          address: response.data.address1,
          categoryId: response.data.categoryID,
        }));
      }
    };
    const fetchCustomerUser = async () => {
      const response = await api.get("/user/customerUser", {
        params: { email: formData.email },
      });
      if (response.status === 200) {
        setFormData((prev) => ({
          ...prev,
          packageID: response.data.packageCode,
          username: prev.userName,
          name: prev.fullName,
        }));
        fetchCustomer(response.data.customerID);
      }
    };

    const fetchStartDate = async () => {
      //  const response = await api.get("/user/profile", {
      //    params: { username: formData.username },
      //  });
       const expiryDate = formData?.expiryDate;

      if (expiryDate) {
        const dateObj = new Date(expiryDate);
        dateObj.setDate(dateObj.getDate() + 1);

        // format to YYYY-MM-DD (local time)
        const year = dateObj.getFullYear();
        const month = String(dateObj.getMonth() + 1).padStart(2, "0");
        const day = String(dateObj.getDate()).padStart(2, "0");
        const nextDay = `${year}-${month}-${day}`;

        console.log(dateObj);
        console.log(nextDay);

        setTargetedStartDate(nextDay);
      }
    }

    if (!formData.packageID) {
      console.log("Tests");
      fetchCustomerUser();
    }else{
      console.log("Have package ID");
      console.log(formData.username);
      
      fetchStartDate();
    }


  }, [formData, paymentCategories]);

  useEffect(() => {
    const fetchPackageList = async () => {
      try {
        const response = await api.get("/packageList");
        const data = response.data;

        const selectedPackage = data.find(
          /* eslint-disable eqeqeq */
          (pkg) => Number(pkg.packageCode) == formData?.packageID
        );
        /* eslint-enable eqeqeq */

        if (selectedPackage) {
          setUserPackage(selectedPackage);
        }
      } catch (err) {
        console.error("Error fetching package list:", err);
      }
    };

    if (formData?.packageID) {
      fetchPackageList();
    }
  }, [formData]);

  const validateFields = () => {
    let newErrors = {
      method: "",
      option: "",
      email: "",
      years: "",
      ids: "",
      targetedStartDate: "",
    };

    if (!selectedMethod) newErrors.method = "Please select a payment method.";
    if (
      selectedMethod !== "loPo" &&
      selectedMethod !== "invoice" &&
      selectedMethod !== "creditCard" &&
      selectedMethod !== "onlineBanking" &&
      !selectedPaymentId
    )
      newErrors.option = "Please select a payment option.";
    if (!email) newErrors.email = "Please enter an email.";
    if (
      (selectedMethod === "loPo" || selectedMethod === "invoice") &&
      years < 1
    )
      newErrors.years = "Years must be at least 1.";
    if ((selectedMethod === "loPo" || selectedMethod === "invoice") && ids < 1)
      newErrors.ids = "IDs must be at least 1.";
    if (selectedMethod === "loPo" && !targetedStartDate)
      newErrors.targetedStartDate = "Please select a targeted start date.";

    setErrors(newErrors);
    return Object.values(newErrors).every((error) => error === "");
  };

  const getRequestId = () => {
    return formData
      .map((item) => item.request?.id)
      .filter((id) => id !== undefined && id !== null)
      .join(" | ");
  };

  const downloadPdf = () => {
    if (!file) return;

    // Fetch the Blob from the file URL
    fetch(file)
      .then((res) => res.blob())
      .then((blob) => {
        // Use downloadjs to download the PDF
        download(blob, fileName, "application/pdf");
      })
      .catch((err) => console.error("Error downloading PDF:", err));
  };
  const handlePayment = async () => {
    if (!validateFields()) {
      return;
    }
    const sstMultiplier = 1 + userPackage?.sstPercent / 100;

    setLoading(true);
    if (Array.isArray(formData)) {
      const response = await api.post("/ewarta/checkout", {
        paymentId: selectedPaymentId,
        amount: formattedTotalPrice,
        userName: formData[0]?.request?.userId?.username,
        prodDesc: getRequestId(),
        userEmail: email,
      });

      if (response.data) {
        const form = document.createElement("form");
        form.method = "POST";
        form.action = "https://payment.ipay88.com.my/epayment/entry.asp";

        Object.keys(response.data).forEach((key) => {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = key;
          input.value = response.data[key];
          form.appendChild(input);
        });

        document.body.appendChild(form);
        form.submit();
      }

      return;
    }
    if (selectedMethod === "loPo") {
      const mergedPayload = {
        ...formData,
        amount:
          (Number(userPackage?.packagePrice) || 0) *
          (Number(years) || 0) *
          (Number(ids) || 0) *
          sstMultiplier,
        numOfSession: ids,
        years,
        targetedStartDate,
        agencyId: formData?.govAgencyId,
      };

      const updateSession = await api.post(
        "/user/updateSession",
        mergedPayload
      );
      if (updateSession.status !== 200) {
        alert("Failed to register user.");
        return;
      }
      const response = await api.post("/api/payment/quotation", {
        userEmail: email,
        packageId: userPackage?.packageCode,
        amount:
          (Number(userPackage?.packagePrice) || 0) *
          (Number(years) || 0) *
          (Number(ids) || 0) *
          sstMultiplier,
        session: ids,
        year: years,
        targetedStartDate,
        address: formData?.address1,
        fullname: formData?.name,
        agencyId: formData?.govAgencyId,
        userName: formData?.username,
        categoryId: formData?.categoryId,
      });

      const pdfData = response.data.pdfData;

      const byteCharacters = atob(pdfData);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);

      const blob = new Blob([byteArray], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);

      setFile(url);
      setFileName("Lawnet Quotation");
      setIsModalOpen(true);
      return;
    }

    if (selectedMethod === "invoice") {
      const mergedPayload = {
        ...formData,
        amount:
          (Number(userPackage?.packagePrice) || 0) *
          (Number(years) || 0) *
          (Number(ids) || 0) *
          sstMultiplier,
        numOfSession: ids,
        years,
        targetedStartDate,
        agencyId: formData?.govAgencyId,
      };

      const updateSession = await api.post(
        "/user/updateSession",
        mergedPayload
      );
      if (updateSession.status !== 200) {
        alert("Failed to register user.");
        return;
      }
      const response = await api.post("/api/payment/invoice", {
        email,
        packageId: userPackage?.packageCode,
        amount: parsePrice(userPackage?.packagePrice),
        session: ids,
        year: years,
        targetedStartDate,
        address: formData?.address1,
        fullname: formData?.name,
        agencyId: formData?.govAgencyId,
        userName: formData?.username,
      });
      const pdfData = response.data.pdfData;

      const byteCharacters = atob(pdfData);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);

      const blob = new Blob([byteArray], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);

      setFile(url);
      setFileName("Lawnet Invoice");
      setIsModalOpen(true);
      return;
    }
    try {
      const response = await api.post("/api/payment-request", {
        userEmail: email,
        packageId: userPackage?.packageCode,
        amount: parsePrice(userPackage?.packagePrice),
        paymentId: selectedPaymentId,
        userName: formData?.username,
      });

      if (response.data) {
        const form = document.createElement("form");
        form.method = "POST";
        form.action = "https://payment.ipay88.com.my/epayment/entry.asp";

        Object.keys(response.data).forEach((key) => {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = key;
          input.value = response.data[key];
          form.appendChild(input);
        });

        document.body.appendChild(form);
        form.submit();
      } else {
        alert("Invalid payment response data.");
      }
    } catch (error) {
      alert("Failed to process payment. Please try again.");
    }
    setLoading(false);
  };

  const parsePrice = (price) => {
    const sstMultiplier = 1 + userPackage?.sstPercent / 100;
    return Math.trunc(Number(price) * sstMultiplier).toFixed(2);
  };

  const calculateTotalPrice = (item) => {
    const ctcFee = item.ctc !== 0 ? 5 : 0;
    const pageCount = item.wartaDocumentId.totalPages;
    const total = (pageCount * 5 + ctcFee) * 1.08;
    return total;
  };

  const totalPrice = Array.isArray(formData)
    ? formData.reduce((sum, item) => sum + calculateTotalPrice(item), 0)
    : 0;
  const formattedTotalPrice = totalPrice.toFixed(2);
  const closeModal = () => {
    setIsModalOpen(false);
    setFile(null);
    setLoading(false);
    if(selectedMethod === "invoice") {
      navigate("/invoice")
    } else {
      navigate("/quotation");
    }
  };
  return (
    <div className="payment-body">
      <div className="payment-container">
        {/* Centered Logo */}
        <div style={{ display: "flex", justifyContent: "center" }}>
          <img height={60} src={LawnetLogo} alt="" />
        </div>

        {Array.isArray(formData) ? (
          <>
            <div className="input-group">
              <label>Description:</label>
              <input type="text" value="Gazette On Demand Documents" readOnly />
            </div>
          </>
        ) : (
          <div className="input-group">
            <label>Package:</label>
            <input type="text" value={userPackage?.packageName} readOnly />
          </div>
        )}
        <div className="input-group" style={{ marginBottom: "10px" }}>
          <label>Price (RM):</label>
          <input
            type="text"
            value={
              Array.isArray(formData)
                ? formattedTotalPrice
                : parsePrice(userPackage?.packagePrice)
            }
            readOnly
          />
        </div>

        <h2>1. Choose Payment Channel</h2>
        <div className="radio-group">
          {filteredCategories.map((category) => (
            <label
              key={category.key}
              className="radio-label"
              style={{ width: "fit-content" }}
            >
              <input
                type="radio"
                name="paymentMethod"
                value={category.key}
                checked={selectedMethod === category.key}
                onChange={(e) => {
                  setSelectedMethod(e.target.value);
                  setSelectedPaymentId(
                    e.target.value === "creditCard"
                      ? "2"
                      : e.target.value === "onlineBanking"
                      ? "16"
                      : ""
                  );
                  setErrors({
                    method: "",
                    option: "",
                    email: "",
                    years: "",
                    ids: "",
                    targetedStartDate: "",
                  });
                }}
              />
              {category.label}
            </label>
          ))}
        </div>

        {(selectedMethod === "loPo" || selectedMethod === "invoice") && (
          <>
            <div className="input-group">
              <h2>2. No of Years:</h2>
              <input
                type="number"
                value={years}
                onChange={(e) => setYears(Math.max(1, e.target.value))}
              />
              {errors.years && <p className="form-error">{errors.years}</p>}
            </div>
            <div className="input-group">
              <h2>3. No of IDs :</h2>
              <input
                type="number"
                value={ids}
                onChange={(e) => setIds(Math.max(1, e.target.value))}
              />
              {errors.ids && <p className="form-error">{errors.ids}</p>}
            </div>

            <div className="input-group">
              <h2>4. Targeted Start Date:</h2>
              <input
                type="date"
                value={targetedStartDate}
                onChange={(e) => setTargetedStartDate(e.target.value)}
              />
              {errors.targetedStartDate && (
                <p className="form-error">{errors.targetedStartDate}</p>
              )}
            </div>
          </>
        )}

        <div className="input-group">
          <label>Email Address:</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            required
            readOnly={false}
          />
        </div>
        {errors.email && <span className="form-error">{errors.email}</span>}

        {/* Proceed to Payment Button */}
        <button
          className="login-button"
          onClick={handlePayment}
          disabled={loading}
        >
          {loading
            ? "Please wait..."
            : selectedMethod === "loPo"
            ? "Request Quotation"
            : selectedMethod === "invoice"
            ? "Request Invoice"
            : "Proceed to Payment"}
        </button>
      </div>
      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        pdf={file}
        pageNumber={1}
        downloadPdf={downloadPdf}
      />
    </div>
  );
};

export default PaymentMethod;
